import {useContext, useState} from "react";
import apiRequest from "@services/apiRequest";
import CountryContext from "../../../CountryContext";
import {NotificationsContext} from "../../../ui-components/Notifications";

export const useMergeAccounts = () => {

  // context
  const {country: {code}} = useContext(CountryContext);

  // state
  const [loading, setLoading] = useState(false);

  // handlers
  const sendRequest = async (recipientEmail: string, finalAccountId: number, finalAccountRole: string) => {
    setLoading(true);
    try {
      const response = await apiRequest!.post(
        "/users/merge/request",
        {
          recipient_email: recipientEmail,
          final_account_id: finalAccountId,
          final_account_role: finalAccountRole,
          country_code: code,
        }
      );
      return response as any;  // {request_id, recipient_email, final_account_id, final_account_role, country_code}
    }
    finally {
      setLoading(false);
    }
  }
  const merge = async (destination_id: number) => {
    setLoading(true);
    try {
      const result = await apiRequest!.put("/users/merge", destination_id);
      return result as any;  // {access_token, user_data}
    }
    finally {
      setLoading(false);
    }
  }

  return {loading, sendRequest, merge};
}